import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VRow,[_c(VCol,{attrs:{"cols":"12","md":"6","xl":"4"}},[_c('div',{staticClass:"text-h6 text-md-h5 font-weight-bold pb-2"},[_vm._v(" Clients ")]),_c('client-selector',{attrs:{"clients":_vm.clients,"loading":_vm.loading,"background-color":"white","can-be-empty":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }